import React from 'react';
import { StatusFlag } from '../../../../domain/FilterTypes';

interface ListingDetailsStatusBodyProps {
  statusFlags: StatusFlag[];
  onChange: (statusFlags: StatusFlag[]) => void;
}

const STATUS_OPTIONS: { flag: StatusFlag; label: string }[] = [
  { flag: 'new', label: 'New' },
  { flag: 'active', label: 'Active' },
  { flag: 'back_on_market', label: 'Back on Market' },
  { flag: 'active_pending', label: 'Active Pending' },
  { flag: 'coming_soon', label: 'Coming Soon' },
];

export const ListingDetailsStatusBody = ({ statusFlags, onChange }: ListingDetailsStatusBodyProps) => {
  const handleCheckboxChange = (flag: StatusFlag, checked: boolean) => {
    if (checked) {
      onChange([ ...statusFlags, flag ]);
    } else {
      onChange(statusFlags.filter(f => f !== flag));
    }
  };

  return (
    <div>
      <h3 className="font-semibold text-gray-900 mb-3">Status</h3>
      <div className="space-y-2">
        {STATUS_OPTIONS.map(({ flag, label }) => (
          <label key={flag} className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={statusFlags.includes(flag)}
              onChange={(e) => handleCheckboxChange(flag, e.target.checked)}
              className="w-4 h-4 text-blue-600  border-gray-600 rounded"
            />
            <span className="text-sm text-gray-700">{label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
